import {
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'cmps-coaching-commitment-goal-summary',
    template: ` <div class="cmps-coaching-commitment-goal-summary--header-row">
            <div class="cmps-coaching-commitment-goal-summary--header-metric">
                {{ metricLabel }}
            </div>
            <div class="cmps-coaching-commitment-goal-summary--header-other">
                {{ percentRemainingLabel }}
            </div>
            <div class="cmps-coaching-commitment-goal-summary--header-other">
                {{ daysToAchievementLabel }}
            </div>
        </div>
        <ng-content></ng-content>`,
    host: {
        class: 'cmps-coaching-commitment-goal-summary',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmpsCommitmentGoalSummaryComponent {
    @Input() metricLabel: string;
    @Input() percentRemainingLabel: string;
    @Input() daysToAchievementLabel: string;
}
